export const conversionRatesApiHandler = {
  getLatestConversionRate: {
    method: "GET",
    path: () => `org-conversion-rate`
  },
  createConversionRate: {
    method: "POST",
    path: () => `org-conversion-rate`
  },
  getConversionRateHistory: {
    method: "GET",
    path: () => `org-conversion-rate/all-rates`,
    params: {} as {'skip'?: string | number, 'take'?: string | number}
  }
};